(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["el-gallery"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.ELGallery) {
      window.ELGallery.buildNav();
      return;
    }

    var state = { items: [], index: 0, trigger: null, title: '' };
    var dialog = null;
    var touchX = null;

    var icons = {
      prev: '<svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M15 18l-6-6 6-6"/></svg>',
      next: '<svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M9 18l6-6-6-6"/></svg>',
      close: '<svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M18 6L6 18"/><path d="M6 6l12 12"/></svg>'
    };

    function buildDialog() {
      if (dialog) return dialog;
      dialog = document.createElement('dialog');
      dialog.className = 'el-lightbox';
      dialog.setAttribute('aria-label', 'Visionneuse de photos');
      dialog.innerHTML =
        '<div class="el-lightbox__inner">' +
          '<p class="el-lightbox__title"></p>' +
          '<button type="button" class="el-lightbox__btn el-lightbox__close" aria-label="Fermer la visionneuse">' + icons.close + '</button>' +
          '<button type="button" class="el-lightbox__btn el-lightbox__prev" aria-label="Photo précédente">' + icons.prev + '</button>' +
          '<figure class="el-lightbox__figure">' +
            '<img class="el-lightbox__img" alt="">' +
            '<figcaption class="el-lightbox__figcaption"><span class="el-lightbox__caption"></span><span class="el-lightbox__counter"></span></figcaption>' +
          '</figure>' +
          '<button type="button" class="el-lightbox__btn el-lightbox__next" aria-label="Photo suivante">' + icons.next + '</button>' +
        '</div>';
      document.body.appendChild(dialog);

      dialog.querySelector('.el-lightbox__close').addEventListener('click', close);
      dialog.querySelector('.el-lightbox__prev').addEventListener('click', function () { go(-1); });
      dialog.querySelector('.el-lightbox__next').addEventListener('click', function () { go(1); });
      dialog.addEventListener('click', function (event) {
        if (event.target === dialog || event.target.classList.contains('el-lightbox__inner')) close();
      });
      dialog.addEventListener('close', function () {
        document.documentElement.style.removeProperty('overflow');
        if (state.trigger && document.contains(state.trigger)) state.trigger.focus();
      });
      dialog.addEventListener('keydown', function (event) {
        if (event.key === 'ArrowLeft') { event.preventDefault(); go(-1); }
        if (event.key === 'ArrowRight') { event.preventDefault(); go(1); }
      });
      dialog.addEventListener('touchstart', function (event) {
        touchX = event.changedTouches[0].clientX;
      }, { passive: true });
      dialog.addEventListener('touchend', function (event) {
        if (touchX === null) return;
        var delta = event.changedTouches[0].clientX - touchX;
        touchX = null;
        if (Math.abs(delta) > 45) go(delta < 0 ? 1 : -1);
      }, { passive: true });
      return dialog;
    }

    function render() {
      var item = state.items[state.index];
      if (!item) return;
      var img = dialog.querySelector('.el-lightbox__img');
      var multiple = state.items.length > 1;
      img.classList.add('is-loading');
      img.onload = function () { img.classList.remove('is-loading'); };
      img.src = item.getAttribute('data-full');
      img.alt = item.getAttribute('data-alt') || '';
      dialog.querySelector('.el-lightbox__caption').textContent = item.getAttribute('data-caption') || '';
      dialog.querySelector('.el-lightbox__counter').textContent = multiple ? (state.index + 1) + ' / ' + state.items.length : '';
      dialog.querySelector('.el-lightbox__title').textContent = state.title;
      dialog.querySelector('.el-lightbox__prev').hidden = !multiple;
      dialog.querySelector('.el-lightbox__next').hidden = !multiple;
      [state.index - 1, state.index + 1].forEach(function (i) {
        var neighbour = state.items[(i + state.items.length) % state.items.length];
        if (neighbour) { var pre = new Image(); pre.src = neighbour.getAttribute('data-full'); }
      });
    }

    function go(step) {
      if (state.items.length < 2) return;
      state.index = (state.index + step + state.items.length) % state.items.length;
      render();
    }

    function open(trigger) {
      var section = trigger.closest('[data-el-gallery]');
      state.items = Array.prototype.slice.call(section.querySelectorAll('[data-el-gallery-item]'));
      state.index = Math.max(0, state.items.indexOf(trigger));
      state.trigger = trigger;
      state.title = section.getAttribute('data-gallery-label') || '';
      buildDialog();
      render();
      document.documentElement.style.overflow = 'hidden';
      if (typeof dialog.showModal === 'function') {
        dialog.showModal();
      } else {
        dialog.setAttribute('open', '');
      }
      dialog.querySelector('.el-lightbox__close').focus();
    }

    function close() {
      if (!dialog) return;
      if (typeof dialog.close === 'function') {
        dialog.close();
      } else {
        dialog.removeAttribute('open');
        document.documentElement.style.removeProperty('overflow');
      }
    }

    function buildNav() {
      var navs = document.querySelectorAll('[data-el-gallery-nav]');
      if (!navs.length) return;
      var sections = Array.prototype.slice.call(document.querySelectorAll('[data-el-gallery]')).filter(function (s) {
        return parseInt(s.getAttribute('data-gallery-count'), 10) > 0;
      });
      Array.prototype.forEach.call(navs, function (nav) {
        if (sections.length < 2) {
          nav.hidden = true;
          return;
        }
        var html = '<span class="el-gallery__nav-label">Catégories</span>';
        sections.forEach(function (s) {
          var label = s.getAttribute('data-gallery-label') || 'Galerie';
          var safe = label.replace(/[&<>"]/g, function (c) {
            return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c];
          });
          html += '<a href="#' + s.id + '">' + safe + ' <span>' + s.getAttribute('data-gallery-count') + '</span></a>';
        });
        nav.innerHTML = html;
        nav.hidden = false;
      });
    }

    document.addEventListener('click', function (event) {
      var trigger = event.target.closest && event.target.closest('[data-el-gallery-item]');
      if (!trigger) return;
      event.preventDefault();
      open(trigger);
    });

    document.addEventListener('shopify:section:load', buildNav);
    document.addEventListener('shopify:section:unload', function () { setTimeout(buildNav, 0); });

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', buildNav);
    } else {
      buildNav();
    }

    window.ELGallery = { buildNav: buildNav, open: open, close: close };
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
